import datamethods from './datamethods.js'
import {mapFields} from 'vuex-map-fields'
import axios from "axios";
export default{
    mixins:[datamethods],
    computed:{
        ...mapFields([
            'loggedInUser',
            'businessDayId',
            'terminalId',
            'responseMessage',
            'ticket',
            'panels',
            'inPayment',
            'payItems',
            'payTotal',
            'cartTotal',
            'due',
            'change',
            'isCash',
            'guest',
            'guestAccounts',
            'receiptIP',
            'cartEligibleForFA',
            'faBalance',
            'arPaymentItemSubtypes',
            'isCompletable',
            'addingProduct',
            'pleaseWait',
            'terminalInfo',
            'receiptData',
            'haveUnprocessedCard',
            'processedCardTotal',
            'inventoryActionReason',
            'terminalresponsestring',
            'usingGeniusTerminal'
            
    
        ]),
        data(){
            return{
              
            }
        },
        voidByTerminal(){
                if(window.VOID_CARD_BY_TERMINAL==undefined){return true}
                else{return window.VOID_CARD_BY_TERMINAL}
      },
        showKeyedEntryButton(){
          if(window.SHOW_KEYED_ENTRY_BUTTON==undefined){return false}
            else{return window.SHOW_KEYED_ENTRY_BUTTON}
        },
        allowPaymentOverDue(){
          
            if(window.ALLOW_PAYMENT_OVER_DUE==undefined){return true}
            else{return window.ALLOW_PAYMENT_OVER_DUE}
          },
          disablePayments(){
            var single = false
            if(window.SINGLE_PAYMENT!=undefined){single=window.SINGLE_PAYMENT}
            return single && this.payItems.length>0
          },
          disableFA(){
            return !this.cartEligibleForFA  || this.faBalance<=0
          },
          fadefaultpay(){
            if(this.faBalance>this.due){return this.due}
            else{return this.faBalance}
          },
          isMultipleCard(){
            let temp = this.payItems;
            if(temp!=undefined){
                temp = temp.filter((item)=>{
                    return (item.name.toLowerCase()=='card')
                })
            }        
            return temp.length>1
          },
          includesCash(){
            let inclCash = false
            if(this.ticket.paymentItems!=undefined){
              this.ticket.paymentItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    if(li.typeName.toLowerCase()=='cash' ){
                        inclCash=true
                    }
                } 
            }
           // console.log('includes cash')
            return inclCash
          },
          includesCardCheckGift(){
            let incl = false
            if(this.ticket.paymentItems!=undefined){
              this.ticket.paymentItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    if(li.typeName.toLowerCase()=='card' || li.typeName.toLowerCase()=='check' || li.typeName.toLowerCase()=='gift' ){
                        incl=true
                    }
                } 
            }
           // console.log('includes cash cd ch or gift')
            return incl
          },
          payItems_unprocessedCardOnly(){
            
            let temp = this.payItems;
            if(temp!=undefined){
                temp = temp.filter((item)=>{
                    return (item.name.toLowerCase()=='card' && item.authorizationCode==null)
                })
            }        
            return temp
                   
          },
          unprocessedCardCount(){
            if(!this.integratedCards){return 0}
            return this.payItems_unprocessedCardOnly.length
          },
          showPayMultCard(){
            return this.isMultipleCard && this.unprocessedCardCount>0
          },
          zeroDue:function(){
            return this.due==0
          },
          payButtonText: function() {
            if (this.inPayment) {
              return "Processing Payment. Please wait...";
            } else {
              return "Process Payment";
            }
          },
          completeText(){
            if(this.haveUnprocessedCard){
              return "Process Card and Complete Transaction"
      
            }else{
              return "Complete Transaction"
            }
          },
          accountBalance(){
            if(this.guestAccounts==undefined){ return -1; }
            if(this.guestAccounts.length==0){return -1}
            return this.guestAccounts[0].currentBalance
      
          },
          
          accountBalanceLabel(){
            var acctlabel="Account"
            if(window.ACCOUNT_LABEL!=undefined){acctlabel=window.ACCOUNT_LABEL}
            var bal = this.accountBalance;
            if(bal==-1){
              return "No Account Available"
            }else{
              return acctlabel + ": " + this.$options.filters.toCurrency(bal)
            }
            
          },
          arLabel(){
            var lbl = "AR"
            if(this.ARPaymentItemSubtypeName!=null){
              lbl = this.ARPaymentItemSubtypeName
            }
            return lbl
          },
          faBalanceLabel(){
            var acctlabel="Financial Aid"
            var bal = this.faBalance;
            if(bal==-1){
              return "No Financial Aid Available"
            }else{
              return acctlabel + ": " + this.$options.filters.toCurrency(bal)
            }
          },
          accountAllLabel(){
            var acctlabel="Account"
            if(window.ACCOUNT_LABEL!=undefined){acctlabel=window.ACCOUNT_LABEL}
            return "Pay All Now with " + acctlabel 
          },
          AutoStartOver(){
            if(window.AUTO_START_OVER==undefined){return false}
            else{return window.AUTO_START_OVER}
          },
          integratedCards(){
            
            if(window.INTEGRATED_CARDS==undefined){return false}
            else{return window.INTEGRATED_CARDS}
          },
          showCheck(){
            
            if(window.SHOW_CHECK==undefined){return false}
            else{return window.SHOW_CHECK}
          },
          showAR(){
            
            if(window.SHOW_AR==undefined){return false}
            else{return window.SHOW_AR}
          },
          showCash(){
            if(window.SHOW_CASH==undefined){return false}
            else{return window.SHOW_CASH}
          },
          showBankcard(){
            if(window.SHOW_BANKCARD==undefined){return false}
            else{return window.SHOW_BANKCARD}
          },
          showGiftcard(){
            if(window.SHOW_GIFTCARD==undefined){return false}
            else{return window.SHOW_GIFTCARD}
          },
          showGiftCertificate(){
            if(window.SHOW_GIFTCERTIFICATE==undefined){return false}
            else{return window.SHOW_GIFTCERTIFICATE}
          },
          showAccount(){
            if(window.SHOW_ACCOUNT==undefined){return false}
            else{return window.SHOW_ACCOUNT}
          },
          showFA(){
            if(window.SHOW_FINANCIALAID==undefined){return false}
            else{return window.SHOW_FINANCIALAID}
          },
          cardNumberDataLabel(){
            if(this.integratedCards){ return ""}
            else {return "Last 4 Digits"}
          },
          checkNumberDataLabel(){
      
            return "Check #"
          },
          certNumberDataLabel(){
            return 'Certificate #'
          },
          showAccountShortcut(){
            if(window.SHOW_ACCOUNT_SHORTCUT==undefined){return false}
            else return window.SHOW_ACCOUNT_SHORTCUT
          },
          receiptPort(){
            if(window.RECEIPT_PORT==undefined){return false}
            else return window.RECEIPT_PORT
          },
          receiptPrinterType(){
            if(this.receiptIP=='laserapple' || this.receiptIP=='newpage'){return 'newpage'}
            else{return 'print'}
          },
          autoReceiptAfterProcess(){
            
            if(window.AUTO_RECEIPT_AFTER_PROCESS==undefined){return false}
            else return window.AUTO_RECEIPT_AFTER_PROCESS && this.includesCardCheckGift
          },
          showCashDrawerButton(){
            
            if(window.SHOW_CASH_DRAWER_BUTTON==undefined){return false}
            else return window.SHOW_CASH_DRAWER_BUTTON
          },
          cashDrawerAutoCash(){
            
            if(window.CASH_DRAWER_AUTO_CASH==undefined){return false}
            else return window.CASH_DRAWER_AUTO_CASH
          },
          cashDrawerAutoAll(){
            
            if(window.CASH_DRAWER_AUTO_ALL==undefined){return false}
            else return window.CASH_DRAWER_AUTO_ALL
          },
          
    },
    methods:{
      autoOpenCashDrawer(){
        //use settings and payment types to determine if open drawer
        
       if(this.includesCardCheckGift && this.cashDrawerAutoAll){
          console.log('auto any pmt type')
          return true
        }else{return false}
      },
        autoPrintReceiptOnSave(name){
            var autoprint=true
            if(window.AUTOPRINT_RECEIPT_FOR_CASH!=undefined)(autoprint=window.AUTOPRINT_RECEIPT_FOR_CASH)
            return name.toLowerCase()=='cash' && autoprint
        },
      addPayItem(type,amt,num,change,guestNumber){
 
        var autoreceipt = this.autoPrintReceiptOnSave(type)
        var newItem;
        //add anew one   
          newItem = {
            id:1,
            name:type,
            price:amt,
            numberData:num,
            changeGiven:change,
            authorizationCode:null,
            guestNumber:guestNumber
            
          }
          /* if(type=='AR'){
            newItem.subTypeId=this.ARPaymentItemSubtypeId
          } */
            
          this.addPayItemToData(newItem,autoreceipt)
          
      },
      addPayItem_ar(type, amt, subtypeid){
        var autoreceipt = this.autoPrintReceiptOnSave(type)
        var newItem;
        //add anew one   
          newItem = {
            id:1,
            name:type,
            price:amt,
            authorizationCode:null,
            subTypeId:subtypeid
          }
  
         
          this.addPayItemToData(newItem,autoreceipt)
      },
      addPayItemAccountAll(){
        this.addPayItem(this.accountBalanceLabel, this.due, null)
      },
      async removepayitem(ItemID){
        if(this.inPayment){return}//if we are processing, don't handle a remove

        console.log('remove item')
        var i;
          for (i = 0; i <= this.payItems.length - 1; i++) {
            if (this.payItems[i].id == ItemID) {
                await this.removePayItemFromData(this.payItems[i])
                this.payItems.splice(i,1)
                break; //only take this one
            }
          }
          this.updatePayTotals(false,true);
      },
      updatePayTotals(autoreceipt=false, refresh=true){
        this.responseMessage=null
        var i;
        var total = 0;
        this.haveUnprocessedCard=false;
        this.processedCardTotal=0

        console.log('update pay total ' + this.payItems.length)
          for (i = 0; i <= this.payItems.length - 1; i++) {

            total = this.addmoney(total, this.payItems[i].price)
            if(this.payItems[i].name.toLowerCase()=='cash'){
              this.isCash=true
            }
            if(this.payItems[i].name.toLowerCase()=='card' && this.payItems[i].authorizationCode==null){
              this.haveUnprocessedCard=true

            }else if(this.payItems[i].name.toLowerCase()=='card' && this.payItems[i].authorizationCode!=null){
              this.processedCardTotal=this.processedCardTotal+this.payItems[i].price
            }
          }

          this.payTotal = total//.toFixed(2);
          //console.log('update pay total2 ' + this.payTotal)
  
          this.due = this.subtractmoney(this.ticket.total,this.payTotal)
          //console.log('set due ' + this.ticket.total + ' ' + this.payTotal + ' ' + this.due)
  
  
  
          //account for change

          if(this.due<0 && this.isCash==true){
            this.change=this.due * -1;
            this.due=0
          }else{
            this.change=0
          }
       
          var amt = this.$options.filters.toCurrency(this.ticket.total);
          this.panels[2].title = 'Payment: ' + amt ;
          //if(this.due==0){
          if(this.due==0 && this.ticket.lineItems.length>0){
            this.panels[2].valid = true;
            this.panels[3].available = true;
  
            //go ahead and get receipt data if we need it
            if(this.receiptIP!='ip'){
              this.getReceiptData(autoreceipt)
            }
          
          }else{
            this.panels[2].valid = false;
            this.panels[3].available = false;
          }
          //this.$emit('refreshticket')
          if(refresh){this.refreshticket()}
      },
      ticketDue(t){
        var total = 0
        var i
          for (i = 0; i <= t.paymentItems.length - 1; i++) {

            total = this.addmoney(total, t.paymentItems[i].amount)
           
          }

     
          var due= this.subtractmoney(t.total,total)
          console.log('this ticket due ' + due)
          return due
      },
      
      async process_terminaltest(){
        console.log('in term test')
        //if we aren't integrated, then skip to the after
        if(this.integratedCards==false){
          this.process()
        }else{
          
          let req = {
            ticket:this.ticket
          }
          //call api
          this.$store.dispatch('beforeAPI');
          //var response = await this.callAPI(req,'terminal')
           var response = await this.callAPI(req,'terminal_bytype')

          //handle response
          if(response.Successful){
            this.terminalInfo=response
  
            //if a processor type was returned, go take that into account
            if(this.terminalInfo.processorType!=null){
              this.processTerminal_ByType()
              return
            }
            //otherwise, its the orig WorldPay integration...stick with that

            //if no payment then move on
            if(this.terminalInfo.payment==null){
          
              this.process(); //do the final processing
              return;
            }
            else if (this.terminalInfo.payment.transactionAmount==null){
             
              this.process(); //do the final processing
              return;
            }
  
            //call 
            this.inPayment=true
            let req2=this.terminalInfo.payment
            let headers = this.terminalInfo.headers
            //headers
            for(let i=0;i < headers.length;i++){
              this.AddHeaderToTerminalAPI(headers[i].key, headers[i].value)
            }
            
            if(this.terminalInfo.uri.includes('refund')){
              var response2 = await this.callAPI_Terminal(req2,'refund')
              this.pleaseWait=false;
              this.completeTerminal(response2)
            }else{
              var response2 = await this.callAPI_Terminal(req2,'sale')
              this.pleaseWait=false;
              this.completeTerminal(response2)
            }
  
            
           
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
        }
  
         
      },
      async completeTerminal(response){
        let req = {
            ticket:this.ticket,
            response:response
          }
          //call api
          this.$store.dispatch('beforeAPI');
          this.pleaseWait=true
          var response = await this.callAPI(req,'terminalcomplete_bytype')
  
          //handle response
          this.inPayment=false
          if(response.Successful){
            
            this.process() //finish!
          }else{
            this.responseMessage = response.Message
            //this.$emit('refreshticketrebuild',this.responseMessage)
            this.refreshticket(false,response.Message)
            
          }
      },
  
      //single item only!!
      async process_terminaltest_single(payItem){
        var item = {
          id:payItem.id,
          amount:payItem.price,
          guestNumber:payItem.guestNumber,
          terminalId:this.ticket.terminalId
        }
  
  
        //if we aren't integrated, then skip to the after
        if(this.integratedCards==false){
          this.process()
        }else{
          let req = {
            ticketPaymentItem:item,
            locationId:this.ticket.locationId
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'terminal_byitem_bytype')
  
          //handle response
          if(response.Successful){
            this.terminalInfo=response
  
            //if a processor type was returned, go take that into account
            if(this.terminalInfo.processorType!=null){
              this.processTerminal_ByType_ByItem(payItem)
              return
            }
            //otherwise, its the orig WorldPay integration...stick with that





            //if no payment then move on
            if(this.terminalInfo.payment==null){
 
              return
            }
            else if (this.terminalInfo.payment.transactionAmount==null){
              
              return
            }
  
            //call 
            let req2=this.terminalInfo.payment
            let headers = this.terminalInfo.headers
            //headers
            for(let i=0;i < headers.length;i++){
              this.AddHeaderToTerminalAPI(headers[i].key, headers[i].value)
            }
            
            var response2 = await this.callAPI_Terminal(req2,'sale')
            console.log(response2)
            this.completeTerminal_single(response2,item)
           
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
        }
  
         
      },
      async completeTerminal_single(response,item){
        let req = {
            ticket:this.ticket,
            ticketPaymentItem:item,
            response:response
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'terminalcomplete_byitem')
  
          //handle response
          if(response.Successful){
            //instead of finishing ...we just refresh!
            //this.$emit('refreshticketrebuild',this.responseMessage)
            this.refreshticket()
          }else{
            this.responseMessage = response.Message
            //this.$emit('refreshticketrebuild',this.responseMessage)
            this.refreshticket(false,response.Message)
            
          }
      },

      //bytype terminal processing
      async processTerminal_ByType(){
        switch (this.terminalInfo.processorType) {
          case 'genius':
            if(this.terminalInfo.uri==null){
          
              this.process(); //do the final processing
              return;
            }

            //call 
            this.inPayment=true
              //override the ip in the terminalinfo
              var override = window.TERMINAL_IP_OVERRIDE
              console.log(override)
              if(override!=undefined){
                
                this.terminalInfo.uri=this.terminalInfo.uri.replace('0.0.0.0',override)
              }

              try {
                this.usingGeniusTerminal=true
                var response2 = await axios.get(this.terminalInfo.uri)
                // ,{timeout:10*1000}
                this.terminalresponsestring=response2
                this.pleaseWait=false;
                this.usingGeniusTerminal=false
                this.completeTerminal_bytype(response2.data)
              } catch (err) {
                  if (err.code === 'ECONNABORTED') {
                    console.error('Request timed out!');
                    this.handleTerminalTimeout(this.terminalInfo.uri)
                  } else {
                    console.error(err);
                    this.handleTerminalTimeout(this.terminalInfo.uri)
                  }
                  this.usingGeniusTerminal=false
              }
            break;
        
          default:
            break;
        }
        
      },
      async processTerminal_ByType_ByItem(payItem){
          switch (this.terminalInfo.processorType) {
          case 'genius':
            if(this.terminalInfo.uri==null){
          
              this.process(); //do the final processing
              return;
            }

            //call 
            this.inPayment=true
              //override the ip in the terminalinfo
              var override = window.TERMINAL_IP_OVERRIDE
              console.log(override)
              if(override!=undefined){
                
                this.terminalInfo.uri=this.terminalInfo.uri.replace('0.0.0.0',override)
              }

              try {
                this.usingGeniusTerminal=true
                var response2 = await axios.get(this.terminalInfo.uri)
                // ,{timeout:10*1000}
                this.terminalresponsestring=response2
                this.pleaseWait=false;
                this.usingGeniusTerminal=false
                this.completeTerminal_byitem_bytype(response2.data,payItem)
              } catch (err) {
                  
                  
                  if (err.code === 'ECONNABORTED') {
                    console.error('Request timed out!');
                    this.handleTerminalTimeout(this.terminalInfo.uri)
                  } else {
                    console.error(err);
                    this.handleTerminalTimeout(this.terminalInfo.uri)
                  }
                  this.usingGeniusTerminal=false
              }
            break;
        
          default:
            break;
        }
      },
      async handleTerminalTimeout(uri){
        let req = {
            ticket:this.ticket,
            responseString:uri
          }
          //call api
          this.$store.dispatch('beforeAPI');
          this.pleaseWait=true
          var response = await this.callAPI(req,'terminaltimeout_bytype')
  
          //handle response
          this.inPayment=false
          if(response.Successful){
            
            this.process() //finish!
          }else{
            this.responseMessage = response.Message
            //this.$emit('refreshticketrebuild',this.responseMessage)
            this.refreshticket(false,response.Message)
            
          }
      },
      async startKeyedEntry(){
        var inituri = this.terminalInfo.uri 
        const index = inituri.indexOf("?")
        const uristart = this.terminalInfo.uri.slice(0,index)
        var uri = uristart + '?Action=InitiateKeyedEntry&Format=XML'
        console.log(inituri)
        console.log(uri)
        //var uri = 'http://' + window.TERMINAL_IP_OVERRIDE + ':8080/v2/pos?Action=InitiateKeyedEntry&Format=XML'
        console.log(uri)
        var response2 = await axios.get(uri)
      },
      async startCancelEntry(){
        var inituri = this.terminalInfo.uri 
        const index = inituri.indexOf("?")
        const uristart = this.terminalInfo.uri.slice(0,index)
        var uri = uristart + '?Action=Cancel&Format=XML'
        //var uri = 'http://' + window.TERMINAL_IP_OVERRIDE + ':8080/v2/pos?Action=Cancel&Format=XML'
        console.log(uri)
        var response2 = await axios.get(uri)
      },
      async completeTerminal_bytype(response){
        let req = {
            ticket:this.ticket,
            responseString:response
          }
          //call api
          this.$store.dispatch('beforeAPI');
          this.pleaseWait=true
          var response = await this.callAPI(req,'terminalcomplete_bytype')
  
          //handle response
          this.inPayment=false
          if(response.Successful){
            
            this.process() //finish!
          }else{
            this.responseMessage = response.Message
            //this.$emit('refreshticketrebuild',this.responseMessage)
            this.refreshticket(false,response.Message)
            
          }
      },
      async completeTerminal_byitem_bytype(response,item){
         let req = {
            ticket:this.ticket,
            ticketPaymentItem:item,
            responseString:response
          }
          //call api
          this.$store.dispatch('beforeAPI');
          this.pleaseWait=true
          var response = await this.callAPI(req,'terminalcomplete_byitem_bytype')
  
          //handle response
          this.inPayment=false
          if(response.Successful){
             /* if(this.zeroDue && !this.haveUnprocessedCard){
              this.process()
             }else{ */
              this.refreshticket()
            // }
             
            //this.process() //finish!
          }else{
            this.responseMessage = response.Message
            //this.$emit('refreshticketrebuild',this.responseMessage)
            this.refreshticket(false,response.Message)
            
          }
      },
      
      //inv reason
      needInventoryReason(){
        if(!this.InventoryReasonForRefund){return false}//if setting false, don't even check
        var needReason =false
        if(this.ticket.lineItems!=undefined){
          this.ticket.lineItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let i=arr[index]
                    if(i.isRefund){
                       needReason=true
                    }
                } 
        }
        
        console.log('need inv reason ' + needReason)
                
        return needReason
      },
      getInventoryActionReason(){
        console.log('get inv action reason!')
        this.$refs.refundreason.Show()
      },
      saveInventoryActionReason(reason){
        console.log('save reason')
        this.inventoryActionReason=reason
        this.process()
      },
      saveInventoryActionReason_only(reason){
        console.log('save reason')
        this.inventoryActionReason=reason

      },
      async getreasons(){
            let req = {
              isSetOnHand:this.setonhand,
              isConsume:this.consume,
              isReceive:this.receive
          }

          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'actionreasonlist_refund')
          //handle response
          if(response.Successful){
            this.reasonList = response.ValueList
            var sel = {ID:-1,Name:'<Select Reason>'}
            this.reasonList.unshift(sel)
            this.reason ='<Select Reason>'   
          }else{
              this.responseMessage = response.Message
          }
          this.pleaseWait=false;  
    
        },

        processbuttontext(payItem){
          return 'Process Card for $' + payItem.price.toFixed(2)
        },

      async process(tocomplete=false){
        if(this.addingProduct){return}
        console.log('inpay=true process')
        this.inPayment=true

        //if we need a refund/exchange reason and don't have one, go get it and then come back
        if(this.needInventoryReason() && this.inventoryActionReason==null){
          this.getInventoryActionReason()
          return
        }

        let req = {
            ticket:this.ticket,
            refundReason:this.inventoryActionReason
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'processticketpayment')
          //handle response
       
          if(response.Successful){
            console.log('in process success')
             this.inPayment=false
             if(tocomplete){
              if(this.autoReceiptAfterProcess && this.payTotal>0  ){
                console.log('auto open receipt')
                this.autoOpenedReceiptOptions=true
                this.$refs.receiptoptions.start(null,this.ticket)
              }else{

                this.toComplete()
              }
              
             }else{
              if(this.autoReceiptAfterProcess && this.payTotal>0 ){
                console.log('auto open receipt')
                this.autoOpenedReceiptOptions=true
                this.$refs.receiptoptions.start(null, this.ticket)
              }else{

                this.toNext()
              }
             }  
             
          }else{
            this.responseMessage = response.Message
            this.inPayment=false
            this.pleaseWait=false;
          }
          this.pleaseWait=false;
      },
      openReceiptOptions(guestNumber=null,ticket=null){
          this.$refs.receiptoptions.start(guestNumber,ticket)
      },
      async process_SelectedTicket(t){

        let req = {
            ticket:t,
            refundReason:this.inventoryActionReason
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'processticketpayment')
          //handle response
       
          if(response.Successful){
            console.log('in process success')
             this.inPayment=false
            
          }else{
            this.responseMessage = response.Message
            this.inPayment=false
            this.pleaseWait=false;
          }
          this.pleaseWait=false;
      },
      completeIfAuto(){
        console.log('in complete if auto...')
        if(this.autoOpenedReceiptOptions){
          this.ticket.id=0
          this.toNext()
        }
      },
      async addPayItemToData(item, autoreceipt=false){
        
        let req = {
            ticketPaymentItem:{
              ticketPaymentId:this.ticket.ticketPaymentId,
              ticketId:this.ticket.id,
              typeName:item.name,
              terminalId:this.terminalId,
              businessDayId:this.ticket.businessDayId,
              guestId:this.guest.id,
              amount:item.price,
              numberData:item.numberData,
              guestAccountBalance:this.accountBalance,
              changeGiven:item.changeGiven,
              subTypeId:item.subTypeId,
              guestNumber:item.guestNumber
  
            },
            locationId:this.ticket.locationId
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'addticketpaymentitem')
          //handle response
       
          if(response.Successful){
             item.id=response.ResponseInteger
             this.payItems.push(item);
              this.updatePayTotals(autoreceipt,true)
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
      },
      async removePayItemFromData(item){
        let req = {
            ticketPaymentItem:{
              id:item.id,
              ticketId:this.ticket.id
            }
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'removeticketpaymentitem')
          //handle response
       
          if(response.Successful){
         
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
      },
  
      //receipt
      
        receipt(drawer){
       
          var receiptText
          if(drawer){
            receiptText="drawer"
          }else{
            receiptText= this.receiptData
          }
          //test receipt
          var ePosDev = new epson.ePOSDevice();
          var printer = null
          var ipAddress = this.receiptIP;
  
          //if we don't have an ip...say so
          if(ipAddress==''){
            console.log("no receipt printer IP available. Please check URL and configuration")
            return
          }
  
          var port = this.receiptPort;
          ePosDev.connect(ipAddress, port, callback_connect);
  
          function callback_connect(data) {
            if(data == 'OK') {
              ePosDev.createDevice('local_printer', ePosDev.DEVICE_TYPE_PRINTER, {'crypto' : true, 'buffer' : false}, cbCreateDevice_printer);
            } else {
              console.log(data);
            }
          }
          function cbCreateDevice_printer(devobj, retcode) {
            if( retcode == 'OK' ) {
              printer = devobj;
              console.log(this.printer)
              executeAddedCode();
            } else {
              console.log(retcode);
            }
          }
          function executeAddedCode() {
            console.log('thinking about printing')
            if(receiptText=="drawer"){
              console.log('drawer please')
              printer.addSound(printer.PATTERN_A, 1, 1000);
            }else{
              console.log('receipt please')
              printer.addText(receiptText)
              printer.addCut(printer.CUT_FEED);
            }
            printer.send();
          }
        },
        async getReceiptData(autoreceipt=false){
          let req = {
              ticket:{
                id:this.ticket.id
              }
            }  
              //call api
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(req,'ticketreceipt')
              //handle response
          
              if(response.Successful){
                this.receiptData=response.StringResponse
                this.pleaseWait=false;
                //this.receipt() //print!
                
                if(autoreceipt){this.$refs.printthereceipt.click()}
                
              }else{
                this.responseMessage = response.Message
              }
              this.pleaseWait=false;
        },
        laser(){
  
        },
        receiptOnNewPage(){
        console.log('print receipt new page')
          var mywindow = window.open('', 'PRINT', 'height=650,width=350');
  
          mywindow.document.write('<html><head><title>' + 'receipt'  + '</title>');
          mywindow.document.write('<style>body{white-space:pre-wrap;}</style>');
          mywindow.document.write('</head><body >');
          mywindow.document.write(document.getElementById('receiptdatadiv').innerHTML);
          mywindow.document.write('</body></html>');
  
          mywindow.document.close(); // necessary for IE >= 10
        },
        //money helper functions
    subtractmoney(m1, m2){
      var divide=true
      var m100=Math.round(m1 * 100)
      var m200=Math.round(m2 * 100)

      var diff = Math.round(m100-m200)

      if(divide){
        return diff /100
      }else{
        return diff
      }
      
    },
    
    addmoney(m1, m2){
      var m100=Math.round(m1 * 100)
      var m200=Math.round(m2 * 100)
      var diff = m100+m200
      return diff /100
    },
     async printReceiptDirectForCurrentTicket(guestNumber=null, ticket=null){
      var tickettoprint=this.ticket  
      if(ticket!= null)    {
        tickettoprint=ticket
        }
      
        let req = {
              ticketId:tickettoprint.id,
              guestNumber:guestNumber
            }  
              //call api
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(req,'ticketreceipt_direct')
              //handle response
              this.pleaseWait=false
              if(response.Successful){
                return response.ReceiptPrintJob
                
              }else{
                this.responseMessage = response.Message
              }
              
            },



        //void
      isvoidableticket(t){
          return t.statusName!='Voided' && t.total >0 && (t.authorizedPaymentCount>0 || t.statusName=='CheckedOut')
      },
      iscancelableticket(t){
        return t.statusName!='Voided'   && !this.isvoidableticket(t)
      },
      getRemoveString(name){
        if(name==null || name.includes('T:')){name="this Guest"}
          return 'Do you want to void the ticket for ' + name + '?'
      },
      getCancelString(name,t){
        if(name==null || name.includes('T:')){name="this Guest"}
        var txt='Do you want to cancel the ticket for ' + name + '?'
        if(t.paymentItems.length>0){
          txt = 'Warning! You have added payments to this ticket. ' + txt
        }
         return txt
      },
      async voidPOSTicket(id){
          let req = {
              id:id
          }
          //call api
          // this.$store.dispatch('beforeAPI');
                  
          this.pleaseWait=true
          var response = await this.callAPI(req,'voidposticket')

          //handle response
          this.inPayment=false
          if(response.Successful){
              this.$refs.voidmessagebox.Show()
              this.getAllTickets()
          }else{
              this.responseMessage = response.Message

          }
          this.pleaseWait=false
      },
      
      checkprocess_terminaltest(ID){
          this.savedTicketId=ID
          //stash this so we can go to it after it works
          if(this.canAccess_allowOverride('POS','Void Transaction')){
              //console.log('already has access')
              this.process_terminaltestvoid(ID)
          }

      },
      overrideSuccessful(){
                //console.log('override!!! call success function')
                this.process_terminaltest(this.savedTicketId)
            },

            async process_terminaltestvoid(ID){
                //if we aren't integrated, then skip to the after
                if(this.integratedCards==false){
                    this.voidticket(ID); 
                    return
                }
                let req = {
                    ticket:{
                        id:ID,
                    },
                    isVoid:true
                }
                //call api
                // this.$store.dispatch('beforeAPI');
                   this.pleaseWait=true
                var response = await this.callAPI(req,'terminal')

                //handle response
                if(response.Successful){
                this.terminalInfo=response

                //if no payment then move on
                if(this.terminalInfo.payment==null){
                    console.log('no pmt')
                    this.voidticket(ID); //do the final processing
                    return;
                }
                else if (this.terminalInfo.payment.transactionAmount==null){
                    //console.log('pmt amt 0')
                    this.voidticket(ID); //do the final processing
                    return;
                }

                //call 
                let req2=this.terminalInfo.payment
                let headers = this.terminalInfo.headers
                //headers
                for(let i=0;i < headers.length;i++){
                    this.AddHeaderToTerminalAPI(headers[i].key, headers[i].value)
                }
                
                var response2 = await this.callAPI_Terminal(req2,this.terminalInfo.endpointString)
                //console.log(response2)
                this.completeTerminalvoid(response2, ID)
                
                }else{
                this.responseMessage = response.Message
                }
                this.pleaseWait=false;
               

                
            },
            async completeTerminalvoid(response, ID){
                let req = {
                    ticket:{id:ID},
                    response:response,
                    isVoid:true
                }
                //call api
                // this.$store.dispatch('beforeAPI');
                   this.pleaseWait=true
                var response = await this.callAPI(req,'terminalcomplete')

                //handle response
                if(response.Successful){
                
                    this.voidticket(ID) //finish!
                }else{
                    this.responseMessage = response.Message
                    this.$emit('refreshticketrebuild',this.responseMessage)
                    
                }
            },
            async voidticket(ID){
                this.responseMessage=null
                console.log('invoid')
                let req = {
                    ticket:{
                        id:ID
                    }
                }
                var response = await this.callAPI(req,'voidticket')
                if(response.Successful){
                    //this.$emit('removeticket', ID)
                    this.$refs.voidmessagebox.Show()
                    this.getAllTickets()
                }else{
                    this.responseMessage = response.Message
                }
                this.pleaseWait=false;
            },
            async RemoveTicket(ID){
              this.responseMessage=null
              console.log('incancel')
              let req = {
                  ticket:{
                      id:ID
                  }
              }
              var response = await this.callAPI(req,'cancelticket')
              if(response.Successful){
                  
                  this.getAllTickets()
              }else{
                  this.responseMessage = response.Message
              }
              this.pleaseWait=false;
          },
     
    },

    


}